import React from 'react';
import { useIntl } from 'react-intl';

const Privacy = () => {
  const intl = useIntl();
  const isEnglish = intl.locale === 'en';

  const renderContent = (id: string, fallback: string) => {
    return isEnglish ? fallback : intl.formatMessage({ id });
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-indigo-800 mb-6">
        {renderContent('privacy.title', 'Privacy Policy')}
      </h1>
      <p className="text-lg mb-4">
        {renderContent('privacy.intro', 'At Pokedle, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information.')}
      </p>
      <h2 className="text-2xl font-semibold text-indigo-700 mt-6 mb-3">
        {renderContent('privacy.infoCollected.title', 'Information We Collect')}
      </h2>
      <p className="text-lg mb-4">
        {renderContent('privacy.infoCollected.description', 'We only collect information that is necessary to provide you with the best Pokedle experience. This may include:')}
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>{renderContent('privacy.infoCollected.item1', 'Your username (if you choose to create one)')}</li>
        <li>{renderContent('privacy.infoCollected.item2', 'Your game scores and progress')}</li>
        <li>{renderContent('privacy.infoCollected.item3', 'Device information and IP address for security purposes')}</li>
      </ul>
      <h2 className="text-2xl font-semibold text-indigo-700 mt-6 mb-3">
        {renderContent('privacy.infoUse.title', 'How We Use Your Information')}
      </h2>
      <p className="text-lg mb-4">
        {renderContent('privacy.infoUse.description', 'We use the collected information to:')}
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>{renderContent('privacy.infoUse.item1', 'Provide and improve the Pokedle game experience')}</li>
        <li>{renderContent('privacy.infoUse.item2', 'Maintain game integrity and prevent cheating')}</li>
        <li>{renderContent('privacy.infoUse.item3', 'Communicate important updates or changes to the game')}</li>
      </ul>
      <h2 className="text-2xl font-semibold text-indigo-700 mt-6 mb-3">
        {renderContent('privacy.dataProtection.title', 'Data Protection')}
      </h2>
      <p className="text-lg mb-4">
        {renderContent('privacy.dataProtection.description', 'We implement industry-standard security measures to protect your data from unauthorized access, disclosure, alteration, or destruction.')}
      </p>
      <h2 className="text-2xl font-semibold text-indigo-700 mt-6 mb-3">
        {renderContent('privacy.yourRights.title', 'Your Rights')}
      </h2>
      <p className="text-lg mb-4">
        {renderContent('privacy.yourRights.description', 'You have the right to access, correct, or delete your personal information. If you have any questions or concerns about our Privacy Policy, please contact us.')}
      </p>
    </div>
  );
};

export default Privacy;